import React from "react";

const ObjectiveNumberField = ({ objective, onChange }) => {
  const value = objective.number || "";
  return (
    <label className="col-xs-12">
      {I18n.t("numbering")}
      <input
        type="text"
        name="number"
        className="form-control"
        placeholder={`${objective.autoNumber} (${I18n.t("automatic")})`}
        value={onChange ? value : undefined}
        defaultValue={onChange ? undefined : value}
        onChange={onChange}
      />
    </label>
  );
};

export default ObjectiveNumberField;
